import NewsLetter from "../newsletter/newsletter"
import Team from "../team/team"
import pageBanner from '../../assets/images/page-banner-img.png'
import portfolioVideo from '../../assets/images/portfolio-video-image.jpg'
import portfolioShape from '../../assets/images/portfolio-shape-1.png'
import aboutTwoImg from '../../assets/images/about-two-img.png'
import aboutTwoShape from '../../assets/images/about-two-shape-1.png'
import aboutTwoShape2 from '../../assets/images/about-two-shape-2.png'
import aboutTwoShape3 from '../../assets/images/about-two-shape-3.png'
import aboutTwoShape4 from '../../assets/images/about-two-shape-4.png'
import testimonialsTwoImg from '../../assets/images/testimonials-two-img-1.jpg'
import testimonialsImg2 from '../../assets/images/testimonials-img-2.png'
import testimonialsTwoShape from '../../assets/images/testimonials-two-shape-1.png'

function About() {
    return (
        <>
            <div className="page-banner-area pt-100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="single-page-banner-content">
                                <h1>About Us</h1>
                                <ul>
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>
                                        About Us
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="single-page-banner-img"  >
                                <img src={pageBanner} alt="images" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="portfolio-area-two pt-100">
                <div className="container">
                    <div className="portfolio-item">
                        <div className="row">
                            <div className="col-12">
                                <div className="single-portfolio-content">
                                    <div className="section-title section-title-left">
                                        <span className="top-title top-title-two">Our Portfolio</span>
                                        <h2>Our Successful Projects</h2>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magn amet.</p>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-video-img">
                                                <img src={portfolioVideo} alt="images" />
                                                <div className="video-play">
                                                    <a href="https://www.youtube.com/watch?v=-z-wtyXjFIg" className="popup-youtube">
                                                        <i className='bx bx-play'></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="number-text">
                                                <div className="portfolio-text">
                                                    <span>01</span>
                                                </div>
                                                <p>Repairing Service</p>
                                                <a href="#">
                                                    <h3>Repairing Service</h3>
                                                </a>
                                                <div className="number-shape-one">
                                                    <img src={portfolioShape} alt="images" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Team />
            <div className="history-area pt-100 pb-100 text-white" style={{ background: '#002434' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-4 col-12 mb-3" >
                            <div className="d-flex align-items-center justify-content-center flex-column">
                                <i className="fa-solid fa-home" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                                <h4 className="text-white">Home Served</h4>
                                <p className="text-white">1600</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-12 mb-3" >
                            <div className="d-flex align-items-center justify-content-center flex-column">
                                <i className="fa-solid fa-users" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                                <h4 className="text-white">Team Members</h4>
                                <p className="text-white">25</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-12 mb-3" >
                            <div className="d-flex align-items-center justify-content-center flex-column">
                                <i className="fa-solid fa-calendar-days" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                                <h4 className="text-white">Year in Service</h4>
                                <p className="text-white">40</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about-style-one-area about-style-two10-area  pt-100 pb-100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6" >
                            <div className="single-about-two-img">
                                <div className="about-img-two">
                                    <img src={aboutTwoImg} alt="images" />
                                </div>
                                <div className="about-two-shape-1">
                                    <img src={aboutTwoShape} alt="images" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="single-about-content about-content-two">
                                <span className="left-title">About Us</span>
                                <h2>We Will Make Absolutely Any Place Clean, Neat</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua sed do eiusmod temp sit amet.</p>
                                <div className="single-about-item about-item-two-card" >
                                    <div className="about-icon">
                                        <i className="flaticon-favorite"></i>
                                        <div className="favorite-shape">
                                            <img src={aboutTwoShape3} alt="images" />
                                        </div>
                                    </div>
                                    <h3>Professional Expert</h3>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua.</p>
                                    <div className="about-style-two-shape">
                                        <img src={aboutTwoShape4} alt="images" />
                                    </div>
                                </div>
                                <div className="single-about-item about-item-two-card" >
                                    <div className="about-icon">
                                        <i className="flaticon-wrench"></i>
                                        <div className="favorite-shape">
                                            <img src={aboutTwoShape3} alt="images" />
                                        </div>
                                    </div>
                                    <h3>Professional Expert</h3>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod temp incididunt ut labore et dolore magna aliqua.</p>
                                    <div className="about-style-two-shape">
                                        <img src={aboutTwoShape4} alt="images" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-style-two-shape-1">
                    <img src={aboutTwoShape2} alt="images" />
                </div>
            </div>
            <NewsLetter />
            <div className="testimonial-two-area pb-100">
                <div className="container">
                    <div className="section-title section-title-left">
                        <span className="top-title top-title-two">Our Testimonial</span>
                        <h2>What People Are Saying!</h2>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className="testimonial-two-image">
                                <img src={testimonialsTwoImg} alt="images" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="testimonial-two-slider">
                                <div className="testimonial-two-card">
                                    <div className="row align-items-center">
                                        <div className="col-lg-2 col-md-2">
                                            <div className="testimonial-style-two"></div>
                                        </div>
                                        <div className="col-lg-10 col-12 col-md-10">
                                            <div className="testimonial-bgs-two-text">
                                                <i className="flaticon-quote"></i>
                                                <p>At vero eos et accusamus et iusto odio dignis simos ducimus qui
                                                    praesentium voluptatum quis deleniti atque corrupti quos dolo rese quas molen stias excepturi sint occaecati atque corrupti quos dolo rese quas molen stias.</p>
                                                <div className="sofia-avery">
                                                    <img src={testimonialsImg2} alt="images" />
                                                    <h5>Sofia Avery</h5>
                                                    <p>Cleaning Expert</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="testimonial-two-shape-1">
                                        <img src={testimonialsTwoShape} alt="images" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About